
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: [
    'pageStr',
    'pageName',
    'imageType',
    'imageLinkName',
    'imageLinkHash',
    'largeImage',
    'listStyle',
    'element',
  ],
  setup(props) {
    let imageSuffix = props.imageType
    if (!props.imageType) {
      imageSuffix = 'webp'
    }

    let imgLinkName = props.imageLinkName
    if (!props.imageLinkName) {
      imgLinkName = ''
    }

    let imgLinkHash = '/#' + props.imageLinkHash
    if (!props.imageLinkHash) {
      imgLinkHash = ''
    }

    let markdownListStyle = 'list-style-' + props.listStyle
    if (!props.listStyle) {
      markdownListStyle = ''
    }

    let displayImageLarge = false
    if (props.largeImage === 'true') {
      displayImageLarge = true
    }

    return {
      imageSuffix,
      imgLinkName,
      imgLinkHash,
      markdownListStyle,
      displayImageLarge,
    }
  },
})
